export function resolveIconUrl(iconFileName: string) {
  return `//${CDN_ASSETS}/${BUILD_NUMBER}/icons/${iconFileName}`;
}
